import { render } from "./Academics.vue?vue&type=template&id=2185b44b&scoped=true"
const script = {}

import "./Academics.vue?vue&type=style&index=0&id=2185b44b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2185b44b"]])

export default __exports__